export const ACCOUNT_SELECTION_RETURN_URL_KEY = "accountSelectionReturnUrl";

const ACCOUNT_SELECTION_PATH = "/selectaccount";

const isAccountSelectionUrl = (candidate: string) => {
  try {
    const url = new URL(candidate, window.location.origin);
    return url.origin === window.location.origin && url.pathname.endsWith(ACCOUNT_SELECTION_PATH);
  } catch {
    return false;
  }
};

const currentRelativeUrl = () => window.location.pathname + window.location.search + window.location.hash;

export const saveAccountSelectionReturnUrl = () => {
  try {
    window.sessionStorage.removeItem(ACCOUNT_SELECTION_RETURN_URL_KEY);

    const returnUrl = currentRelativeUrl();
    if (!isAccountSelectionUrl(returnUrl)) {
      window.sessionStorage.setItem(ACCOUNT_SELECTION_RETURN_URL_KEY, returnUrl);
    }
  } catch {
    // Navigation to account selection must still work when sessionStorage is unavailable.
  }
};

export const rememberAccountSelectionReturnUrl = (loginRedirectUrl?: string) => {
  try {
    if (loginRedirectUrl && isAccountSelectionUrl(loginRedirectUrl)) {
      saveAccountSelectionReturnUrl();
    } else {
      window.sessionStorage.removeItem(ACCOUNT_SELECTION_RETURN_URL_KEY);
    }
  } catch {
    // Login navigation must still complete when sessionStorage is unavailable.
  }
};

const sanitizeReturnUrl = (candidate: string) => {
  if (!candidate.startsWith("/") || candidate.startsWith("//") || candidate.includes("\\")) {
    return null;
  }

  try {
    const url = new URL(candidate, window.location.origin);
    if (url.origin !== window.location.origin) {
      return null;
    }
    return url.pathname + url.search + url.hash;
  } catch {
    return null;
  }
};

export const consumeAccountSelectionReturnUrl = () => {
  try {
    const returnUrl = window.sessionStorage.getItem(ACCOUNT_SELECTION_RETURN_URL_KEY);
    window.sessionStorage.removeItem(ACCOUNT_SELECTION_RETURN_URL_KEY);
    return returnUrl ? sanitizeReturnUrl(returnUrl) : null;
  } catch {
    return null;
  }
};
